// "Continue with LinkedIn / Google / Apple" — server-side OAuth.
// The button sends the browser to the backend, which sends it to the provider's own sign-in page.
// The provider returns to the backend, which verifies the sign-in and sends the browser back to
// /auth/social?code=…; that page swaps the one-time code for the normal login response.
const API_BASE = 'https://emiratesscholar.com/system/api';
// Full-page navigation (not fetch), so it goes straight to the backend rather than the dev proxy
const AUTH_BASE = 'https://www.emiratesscholar.com/system/api/auth';

export const SOCIAL_PROVIDERS = ['linkedin', 'google', 'apple'];

// { google: bool, linkedin: bool, … } — a button only shows once its provider is set up on the server
export const fetchSocialProviders = async () => {
  const res = await fetch(`${API_BASE}/auth/social/providers`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`providers ${res.status}`);
  return res.json();
};

export const startSocialLogin = (provider) => {
  window.location.href = `${AUTH_BASE}/${provider}/redirect?return=${encodeURIComponent(window.location.origin)}`;
};

// Same shape as the email/password login: { Profile, UserDetails, userVerified, success: { token } }
export const exchangeSocialCode = async (code) => {
  const res = await fetch(`${API_BASE}/auth/social/exchange`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ code })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || 'Sign-in failed. Please try again.');
  return data;
};

export const PROVIDER_NAMES = {
  google: 'Google', linkedin: 'LinkedIn', apple: 'Apple'
};

// Messages for /?social_error=…&provider=… (sent by the backend when sign-in doesn't complete)
export const socialErrorMessage = (code, provider, t) => {
  const name = PROVIDER_NAMES[provider] || provider || '';
  const tr = (key, fallback) => (t ? t(key, { defaultValue: fallback, provider: name }) : fallback.replace('{{provider}}', name));
  switch (code) {
    case 'cancelled':
      return tr('social_err_cancelled', 'Sign-in with {{provider}} was cancelled.');
    case 'no_email':
      return tr('social_err_no_email', '{{provider}} did not share a verified email address, so we could not sign you in. Please use email and password.');
    case 'deleted':
      return tr('social_err_deleted', 'This account has been deleted.');
    case 'not_configured':
      return tr('social_err_unavailable', 'Sign-in with {{provider}} is not available yet.');
    default:
      return tr('social_err_failed', 'Sign-in with {{provider}} failed. Please try again.');
  }
};
